// extracted by mini-css-extract-plugin
export default {"disableSelect":"src-js-sign-components-common-hooks-module__disableSelect--2zWhS"};